var map = {
	"./components/AsideRightMenu.vue": 7496,
	"./components/Cart.vue": 9398,
	"./components/CartMenuIcon.vue": 2298,
	"./components/CartPopup.vue": 3812,
	"./components/Checkout.vue": 9648,
	"./components/CheckoutManual.vue": 2170,
	"./components/DeleteAddressPopup.vue": 1199,
	"./components/LoginPopup.vue": 9515,
	"./components/NewAddressPopup.vue": 2312,
	"./components/Notifications.vue": 2901,
	"./components/ProductBuy.vue": 1786,
	"./components/ProductBuySimple.vue": 5104,
	"./components/ProductBuyVisite.vue": 7141,
	"./components/ProductDisplayYearAndPrice.vue": 2845,
	"./components/ShopMenuIcon.vue": 6126,
	"./components/SimpleCartIcon.vue": 8451,
	"./components/UserMenu.vue": 3610,
	"./components/partials/BlackshipForm.vue": 1788,
	"./components/partials/ContactForm.vue": 901,
	"./components/partials/DiscountBox.vue": 8117,
	"./components/partials/Newsletter.vue": 7438,
	"./components/partials/OrderAnalytics.vue": 2184,
	"./components/partials/RegistrationAnalytics.vue": 4542,
	"./components/partials/VisitForm.vue": 4281,
	"./components/partials/WineClubPopup.vue": 1180,
	"./components/user-account/AccountUserAddresses.vue": 2469,
	"./components/user-account/AccountUserBilling.vue": 9887,
	"./components/user-account/AccountUserData.vue": 6434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3343;